export const enumPhoneType = {
  unknown: 0,
  workPhone: 1,
  mobilePhone: 2,
  homePhone: 3,
}
